import { z } from "zod";

export const discountDisclaimerSchema = z.discriminatedUnion("enabled", [
  z.object({
    enabled: z.literal(false),
    warningMessage: z.string(),
  }),
  z.object({
    enabled: z.literal(true),
    enabledWhenZeroValueDeposit: z.boolean(),
    disclaimerMessage: z.string(),
    warningMessage: z.string(),
  }),
]);
